import { render, h, toRaw } from 'vue'
import SideNavigationBar from '~/components/navigations/SideNavigationBar.vue'

type Element = {
  el: HTMLElement
  top: number
}

const elements = ref<Element[]>([])
const index = ref(0)
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const i18n = nuxtApp.$i18n as { t: (key: string) => string }
  const $t = i18n.t

  const route = useRoute()

  const payloadData = toRaw(nuxtApp.payload.data)

  nuxtApp.vueApp.directive(`side-navigation`, {

    mounted(el: HTMLElement) {
      router.beforeResolve(() => {
        elements.value = []
      })

      const { data: entry } = getCurrentPayload(route.path, payloadData)

      if (entry && entry.blueprint === 'business_report') {
        el.style.clipPath = 'rect(0px 100% 100% 0px)'

        const bgColor = window.getComputedStyle(el, null).getPropertyValue('background-color')
        const color = bgColor === 'rgba(0, 0, 0, 0)' ? 'black' : 'white'

        // add vue component sidenavigationbar
        const vueComponent = h(SideNavigationBar, {
          color: color as 'white' | 'black',
          elements: elements.value,
          index: index.value,
          entry: entry,
          downloadText: $t('hover_text_for_download_pdf'),
        })

        render(vueComponent, el)
        index.value += 1

        // client only
        if (import.meta.client) {
          nextTick(() => {
            // get elements position in body
            const top = el.getBoundingClientRect().top + document.documentElement.scrollTop

            if (el) {
              elements.value.push({
                el,
                top,
              })
            }

            // sort elements by top position
            elements.value.sort((a, b) => a.top - b.top)
          })
        }
      }
    },
  })
  nuxtApp.vueApp.directive(`side-navigation-only-count`, {
    mounted(el: HTMLElement) {
      if (import.meta.client) {
        nextTick(() => {
        // get elements position in body
          const top = el.getBoundingClientRect().top + document.documentElement.scrollTop

          if (el) {
            elements.value.push({
              el,
              top,
            })
          }

          // sort elements by top position
          elements.value.sort((a, b) => a.top - b.top)
        })
      }
    },
  })
  return {
    provide: {
      elements: elements,
    },
  }
})

// on resize recalc elements top postition
window?.addEventListener(`resize`, () => {
  elements.value.forEach((element) => {
    const top = element.el.getBoundingClientRect().top + document.documentElement.scrollTop
    element.top = top
  })
})

function getCurrentPayload(currentPath: string, payloadData: object) {
  // Find the correct data of the current entry based on the current path
  const currentKey = Object.keys(payloadData).find((key) => {
    const entry = payloadData[key]?.entry
    return entry && typeof entry === 'object' && entry.url === currentPath
  })

  return {
    key: currentKey || null,
    data: currentKey ? payloadData[currentKey]?.entry : null,
  }
}
